import {FILTRAR_RELATORIO_ITINERARIOS} from '../types';


export default function filtrarRelatorioItinerarios(resumo, texto) {
  return {
    type: FILTRAR_RELATORIO_ITINERARIOS,
    payload: { resumo, texto }
  };
}
